import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import axios from "axios";
import "react-phone-input-2/lib/style.css";
import { BACKEND_URL } from "../../../../utils/constants";

import { Loading } from "@/components/Loader/Loading";
import { usePathname } from "next/navigation";
// Dynamically import PhoneInput to prevent SSR issues
const PhoneInput = dynamic(() => import('react-phone-input-2'), { ssr: true });



const Next: React.FC = ({ counter1, formData, setFormData,pageName }) => {
  const [phoneNumber, setPhoneNumber] = useState("");

  const [error, setError] = useState('');
  const [loading, setisLoading] = useState("Next");
  const [phoneNumberEmpty, setPhoneNumberEmpty] = useState("");
  const path = usePathname();
  const isRoute = path.startsWith("/study-mbbs-abroad");


  // const [countryCode, setCountryCode] = useState("+91"); // Default to India (+91)

  // const handleInputChange1 = (e) => {
  //   const { value } = e.target;

  //   // Format the phone number input (you can improve this as needed)
  //   let formattedValue = value.replace(/\D/g, ""); // Remove non-digit characters

  //   setPhoneNumber(formattedValue);
  //   setFormData((prev) => ({
  //     ...prev,
  //     Phone: `${countryCode}${formattedValue}`, // Append the country code
  //   }));
  // };

  // const handleCountryCodeChange = (e) => {
  //   setCountryCode(e.target.value);
  //   setFormData((prev) => ({
  //     ...prev,
  //     Phone: `${e.target.value}${phoneNumber}`, // Reformat with new country code
  //   }));
  // };

  console.log("url", BACKEND_URL);
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handlePhoneChange = (value: string, countryObj) => {
    if (value) {
      const dialCode = countryObj.dialCode;
      const phoneValue = value.replace(/\D/g, "");
      const phoneNo = phoneValue.replace(new RegExp(`^${dialCode}`), '');
      // Format phone number after removing non-digit characters
      const formattedPhone = `+${dialCode}-${phoneNo}`;

      setPhoneNumber(phoneValue);  // Update internal phone state
      setPhoneNumberEmpty(phoneNo)
      setFormData((prev) => ({
        ...prev,
        Phone: formattedPhone,  // Update the form data with the formatted phone number
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        Phone: "",  // Reset phone number if it's empty
      }));
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get("utm_source");
    const utmMedium = urlParams.get("utm_medium");
    const utmCampaign = urlParams.get("utm_campaign");
    const utmTerm = urlParams.get("utm_term");

    // Step 2: Update form data with the UTM parameters
    setFormData((prev) => ({
      ...prev,
      utm_source: utmSource || '',
      utm_medium: utmMedium || '',
      utm_campaign: utmCampaign || '',
      utm_term: utmTerm || '',
    }));
  }, [setFormData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (phoneNumberEmpty == '') {
      setError('Phone number is required');
      return;
    }
    setError('');
    try {
      console.log({ formData });
      const cleanedFormData = Object.fromEntries(
        Object.entries(formData).filter(
          ([, value]) => value !== "" && value !== null && value !== undefined
        )
      );
      cleanedFormData.interestedProgram = pageName;
      console.log({ cleanedFormData });
      setisLoading("false");
      const response = await axios.post(
        `${BACKEND_URL}/lsq/create-lead`,
        cleanedFormData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Form submitted successfully:", response.data);
      if (response.data.message === 'Lead created successfully.' || response.data.message == "Existing lead updated successfully.") {
        setisLoading("Next");
      }
      // Handle success (e.g., show a success message, navigate, etc.)
      counter1();
    } catch (error) {
      console.error("Error submitting form:", error);
      // Handle error (e.g., show an error message)
    }
  };

  return (
    <div
      className=" flex flex-col rounded-lg p-6  mdb:py-4    mdb:w-[35vw] border-2 border-black-500 z-10 relative bg-gray-50"
      style={{ boxShadow: "10px 10px 0px rgba(0, 0, 0, 1)" }}
    >
      <h2 className="  md:text-center text-[20px] sm:text-base xl:whitespace-nowrap xl:text-[20px]  mdb:text-lg 2xl:text-[22px] mb-6 text-black font-semibold font-poppins">
        Get Started on Your Journey to Study Abroad
      </h2>
      <p className="border-2 border-dashed max-w-max border-blue-400 p-1 font-bold rounded-lg text-sm bg-gradient-to-r from-blue-500 to-teal-500 mb-6 text-transparent bg-clip-text font-poppins">
        Apply now for 2025 intake
      </p>
      <form onSubmit={handleSubmit}>
        <div className="flex space-x-4">
          <div className="w-1/2">
            <label
              htmlFor="FirstName"
              className="block text-sm font-medium text-black"
            >
              First Name
            </label>
            <input
              type="text"
              id="FirstName"
              placeholder="First name"
              value={formData.FirstName}
              onChange={handleInputChange}
              onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '')}
              required
              className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="w-1/2">
            <label
              htmlFor="LastName"
              className="block text-sm font-medium text-black"
            >
              Last Name
            </label>
            <input
              type="text"
              id="LastName"
              placeholder="Last name"
              onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '')}
              value={formData.LastName}
              onChange={handleInputChange}
              required
              className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div className="mt-4">
          <label
            htmlFor="EmailAddress"
            className="block text-sm font-medium text-black"
          >
            Email
          </label>
          <input
            type="email"
            id="EmailAddress"
            placeholder="example@email.com"
            value={formData.EmailAddress}
            onChange={handleInputChange}
            required
            className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        {/* <div className="mt-4">
          <label
            htmlFor="Phone"
            className="block text-sm font-medium text-black mb-2"
          >
            Phone Number
          </label>
          <div className="flex items-center space-x-4">
            <select
              id="countryCode"
              value={countryCode}
              onChange={handleCountryCodeChange}
              className="border rounded-md px-4 py-2 w-28 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {countriesWithFlags.map((country,index) => (
                <option key={index} value={country.code}>
                  {country.code} {country.flag}
                </option>
              ))}
            </select>
            <input
              type="text"
              id="Phone"
              placeholder="Phone Number"
              value={phoneNumber}
              onChange={handleInputChange1}
              className="flex w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div> */}

        <div className="mt-4">
          <label htmlFor="Phone" className="block text-sm font-medium text-black">
            Phone Number
          </label>
          <div className="">
            <PhoneInput
              country={'in'}
              value={phoneNumber}
              onChange={handlePhoneChange}
              inputStyle={{ width: '100%' }}
              buttonStyle={{ zIndex: 0 }}

              containerClass="border rounded"
              inputClass="border rounded px-4 py-2"
            />
            {error && <span className="text-red-500">{error}</span>}
          </div>
        </div>
        <button
          type="submit"
          id="next-leadgen"
          className={`mt-6 w-full bg-gradient-to-r from-blue-500 to-teal-500 text-white font-medium py-2 rounded hover:opacity-90 ${isRoute ? 'submit-btn-special' : 'submit-btn-default'}`}
        >
          {loading === 'false' ? <Loading /> : loading}
        </button>
      </form>

      {/* <p className="text-xs text-gray-500 text-center mt-4">
        By submitting the form you agree with the terms and conditions, privacy
        policy
      </p> */}
    </div>
  );
};
export default Next;
